module.exports = __webpack_public_path__ + "static/media/pointsS.cef38cbd.png";